module.exports = __webpack_public_path__ + "img/arrow-down.f5fc730b.svg";